import {
  TRANSPORT_CHANGE_LOADING,
  TRANSPORT_CHANGE_FAILED,
  TRANSPORT_CHANGE_SUCCESS
  } from "../types"
  
  const initialState = {
    loading: false,
    error: false,
    message: null,
  }
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case TRANSPORT_CHANGE_LOADING:
        return {
          ...state,
          loading: true,
          error: false,
          message: null,
        }
      case TRANSPORT_CHANGE_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
          message: action.payload,
        }
      case TRANSPORT_CHANGE_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          message: null,
        }
      default:
        return state
    }
  }
  